import React, { useState } from 'react';
import { Card, Col, Container, Row, Button, Offcanvas, Form, Alert } from 'react-bootstrap';
import ChatHistory from './ChatHistory';
import Modal from "react-modal";
import RemarksRoadmap from '../pages/RemarksRoadMap';
import { API_URL } from '..';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';
import axios from 'axios';
import StatusRoadmap from './StatusRoadmap';
import { Icon } from '@iconify/react';

/**
 * Formats a date string to a readable format (e.g., "12 Jan 2023").
 * @param {string} inputDate - The date string to format.
 * @returns {string} Formatted date.
 */
function formatDate(inputDate) {
    const date = new Date(inputDate);
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    return `${day} ${month} ${year}`;
}

/**
 * ViewAppointmentLayer component displays job details and chat history for a specific job.
 * @param {Object} props - Component props.
 * @param {Object} props.data - Job data containing id, client_name, phone, email, etc.
 * @param {Array} props.jobRemarks - Array of remarks for the job.
 * @returns {JSX.Element} The rendered job details component.
 */
export default function ViewAppointmentLayer({ data, jobRemarks }) {
    const [showChat, setShowChat] = useState(false);
    const senderId = data?.assignedTo?.id || null;
    const [modalIsOpenNew, setModalIsOpenNew] = useState(false);
    const [selectedAttachment, setSelectedAttachment] = useState({
        uri: '',
        status: '',
        createdAt: '',
        description:''
    });
    const [selectedAttachmentSingle, setSelectedAttachmentSingle] = useState(null);
    const [singleModal, setSingleModal] = useState(false);
    const [uploadModal, setUploadModal] = useState(false);
    const [images, setImages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const openAttachmentSingle = (attachment) => {
        setSelectedAttachmentSingle(attachment);
        setSingleModal(true);
    };

    const handleShowChat = () => {
        setShowChat(true);
    };

    const handleCloseChat = () => {
        setShowChat(false);
    };

    const openAttachment = (item) => {
        setModalIsOpenNew(true);
        setSelectedAttachment({
            uri: API_URL + item.image_url,
            status: item.status,
            createdAt: item.createdAt,
            description: item.description,
        });
    };

    const closeAttachment = () => {
        setModalIsOpenNew(false);
        setSelectedAttachment({
            uri: '',
            status: '',
            createdAt: '',
        });
    };

    const closeAttachmentSingle = () => {
        setSingleModal(false);
        setSelectedAttachmentSingle(null);
    };

    const openUploadModal = () => {
        setUploadModal(true);
        setError(null);
        setSuccess(null);
    };

    const closeUploadModal = () => {
        setUploadModal(false);
        setImages([]);
        setError(null);
        setSuccess(null);
    };

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map(file => ({
            file,
            uri: URL.createObjectURL(file),
            status: 'before',
            description: ''
        }));
        setImages(prev => [...prev, ...newImages]);
    };

    const handleStatusChange = (index, status) => {
        setImages(prev => prev.map((img, i) => 
            i === index ? { ...img, status } : img
        ));
    };

    const handleDescriptionChange = (index, description) => {
        setImages(prev => prev.map((img, i) => 
            i === index ? { ...img, description } : img
        ));
    };

    const submitToApi = async () => {
        if (images.length === 0) {
            setError('Please select at least one image');
            return;
        }

        try {
            setIsLoading(true);
            setError(null);
            const formData = new FormData();
            formData.append('job_id', data?.id);

            images.forEach((image, index) => {
                console.log(image)
                formData.append('images',image.file);
                formData.append(`status_${index}`, image.status);
                formData.append(`description_${index}`, image.description || '');
            });

            const response = await axios.post(`${API_URL}/api/job/upload-attachment`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            setIsLoading(false);
            setSuccess('Images uploaded successfully');
            setImages([]);
        } catch (error) {
            setIsLoading(false);
            setError('Failed to upload images');
            console.error('API Error:', error);
        }
    };

    return (
        <Container className="my-4">
            <style>
                {`
                    .section-header {
                        background-color: #f8f9fa;
                        padding: 0.75rem 1.25rem;
                        border-radius: 8px 8px 0 0;
                        border-bottom: 1px solid #dee2e6;
                        font-weight: 600;
                        font-size: 1.1rem;
                        color: #343a40;
                    }
                    .section-body {
                        padding: 1.5rem;
                        border: 1px solid #dee2e6;
                        border-top: none;
                        border-radius: 0 0 8px 8px;
                        background-color: #fff;
                    }
                    .form-label {
                        font-weight: 600;
                        color: #6c757d;
                    }
                    .badge {
                        font-size: 0.85rem;
                        padding: 0.5em 0.75em;
                    }
                    .description ol {
                        list-style: auto;
                        padding-left: 1.5rem;
                    }
                    .modal-content {
                        max-width: 95%;
                        margin: auto;
                        max-height: 90vh;
                        overflow-y: auto;
                        border-radius: 12px;
                        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
                    }
                    .modal-overlay {
                        background: rgba(0, 0, 0, 0.5);
                    }
                    .close-button {
                        position: absolute;
                        top: 10px;
                        right: 10px;
                        background: #dc3545;
                        color: white;
                        border: none;
                        border-radius: 5px;
                        padding: 0.5rem 1rem;
                        cursor: pointer;
                    }
                    .full-screen-image {
                        max-width: 100%;
                        max-height: 70vh;
                        object-fit: contain;
                    }
                    .image-container {
                        margin-bottom: 10px;
                        cursor: pointer;
                        position: relative;
                    }
                    .image-container img {
                        width: 100%;
                        height: auto;
                        border-radius: 8px;
                        border: 1px solid #dee2e6;
                    }
                    .image-container p {
                        margin: 0.5rem 0;
                        font-size: 0.9rem;
                    }
                    .image-status {
                        background: black;
                        color: white;
                        text-transform: uppercase;
                        padding: 0.3rem 0.6rem;
                        border-radius: 4px;
                        text-align: center;
                    }
                    .image-preview {
                        max-width: 150px;
                        max-height: 150px;
                        object-fit: cover;
                        margin: 10px;
                        border-radius: 8px;
                    }
                `}
            </style>

            {/* Attachment Modal */}
            <Modal
                isOpen={modalIsOpenNew}
                onRequestClose={closeAttachment}
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <button className="close-button" onClick={closeAttachment}>
                    Close
                </button>
                {selectedAttachment && selectedAttachment.uri.endsWith(".mp4") ? (
                    <ReactPlayer
                        url={selectedAttachment.uri}
                        controls
                        width="80%"
                        height="70vh"
                        style={{ margin: 'auto' }}
                    />
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <p style={{ margin: '0.5rem 0', fontSize: '0.9rem' }}>
                            {formatDate(selectedAttachment.createdAt)}
                        </p>
                        <p className="image-status">{selectedAttachment.status}</p>
                        <img
                            src={selectedAttachment.uri}
                            alt="Full View"
                            className="full-screen-image"
                        />
                        <strong>Description</strong>
                        <p className="">{selectedAttachment.description}</p>
                    </div>
                )}
            </Modal>

            {/* Single Attachment Modal */}
            <Modal
                isOpen={singleModal}
                onRequestClose={closeAttachmentSingle}
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <button className="close-button" onClick={closeAttachmentSingle}>
                    Close
                </button>
                {selectedAttachmentSingle && selectedAttachmentSingle.endsWith(".mp4") ? (
                    <ReactPlayer
                        url={selectedAttachmentSingle}
                        controls
                        width="80%"
                        height="70vh"
                        style={{ margin: 'auto' }}
                    />
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <img
                            src={selectedAttachmentSingle}
                            alt="Full View"
                            className="full-screen-image"
                        />
                    </div>
                )}
            </Modal>

            {/* Upload Photos Modal */}
            <Modal
                isOpen={uploadModal}
                onRequestClose={closeUploadModal}
                className="modal-content"
                overlayClassName="modal-overlay"
               
            >
                <button className="close-button" onClick={closeUploadModal}>
                    Close
                </button>
                <div style={{ padding: '20px' }}>
                    <h6>Upload Photos</h6>
                    {error && <Alert variant="danger">{error}</Alert>}
                    {success && <Alert variant="success">{success}</Alert>}
                        <Row>
                            <Col md="12">
                            <Form.Group className="mb-3">
                        <Form.Label>Select Images</Form.Label>
                        <Form.Control
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                    </Form.Group>
                    {images.map((image, index) => (
                        <div key={index} className="mb-3">
                            <img src={image.uri} alt={`Preview ${index}`} className="image-preview" />
                            <Form.Group className="mb-2">
                                <Form.Label>Status</Form.Label>
                                <Form.Select
                                    value={image.status}
                                    onChange={(e) => handleStatusChange(index, e.target.value)}
                                >
                                    <option value="before">Before</option>
                                    <option value="after">After</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={image.description}
                                    onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                    placeholder="Enter description for this image"
                                />
                            </Form.Group>
                        </div>
                    ))}
                    <Button
                        variant="primary"
                        onClick={submitToApi}
                        disabled={isLoading}
                        style={{ background: '#db6f2f', borderWidth: 0 }}
                    >
                        {isLoading ? 'Uploading...' : 'Upload Images'}
                    </Button>
                            </Col>
                        </Row>
                </div>
            </Modal>

            {/* Main Card */}
            <Card className="shadow-sm border-0">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="h6 mb-0 text-secondary">Job #{data?.id || 'N/A'}</h5>
                        <div>
                            <Button
                                className='btn btn-primary'
                                style={{ background: '#db6f2f', color: 'white', borderWidth: 0, marginRight: 10 }}
                                onClick={handleShowChat}
                                title="View Chat History"
                            >
                                <i className="bi bi-chat-text me-2"></i>
                                Show Chat
                            </Button>
                            <Button
                                className='btn btn-primary'
                                style={{ background: '#db6f2f', color: 'white', borderWidth: 0, marginRight: 10 }}
                                onClick={openUploadModal}
                                title="Upload Photos"
                            >
                                <i className="bi bi-upload me-2"></i>
                                Upload Photos
                            </Button>
                            <Link
                                style={{ background: '#db6f2f', color: 'white', borderWidth: 0 }}
                                to={`/view-report/${data?.id}`}
                                title="View Report"
                                className='btn btn-primary'
                            >
                                <i className="bi bi-chat-text me-2"></i>
                                Show Report
                            </Link>
                        </div>

                    </div>

                    {/* Client Information */}
                    <div className="section-header mt-3">Client Information</div>
                    <div className="section-body">
                        <Row>
                            <Col xs={12} md={6} className="mb-3">
                                <label className="form-label">Client Name</label>
                                <p>{data?.client_name || 'N/A'}</p>
                            </Col>
                            <Col xs={12} md={6} className="mb-3">
                                <label className="form-label">Client Phone</label>
                                <br />
                                <a className='text-primary' href={`tel:${data.phone}`}> {data?.phone || 'N/A'}</a>
                            </Col>
                        </Row>
                    </div>

                    {/* Job Details */}
                    <div className="section-header">Job Details</div>
                    <div className="section-body">
                        <Row>
                            <Col xs={12} md={6} className="mb-3">
                                <label className="form-label">Reference No</label>
                                <p>{data?.referenceNo || 'N/A'}</p>
                            </Col>
                            <Col xs={12} md={6} className="mb-3">
                                <label className="form-label">Site Address</label>
                                <p>{data?.address || 'N/A'}</p>
                            </Col>
                            <Col xs={12} md={6} className="mb-3">
                                <label className="form-label">Job Cost</label>
                                <p>{data?.job_cost ? `£${parseFloat(data.job_cost).toFixed(2)}` : 'N/A'}</p>
                            </Col>
                            <Col xs={12} md={6} className="mb-3">
                                <label className="form-label">Status</label>
                                <p>
                                    {data?.status === 'new' ? (
                                        <span style={{ textTransform: 'uppercase' }} className="badge bg-primary">
                                            {data.status}
                                        </span>
                                    ) : data?.status === 'accepted' ? (
                                        <span style={{ textTransform: 'uppercase' }} className="badge bg-warning">
                                            active
                                        </span>
                                    ) : data?.status === 'declined' ? (
                                        <span style={{ textTransform: 'uppercase' }} className="badge bg-danger">
                                            {data.status}
                                        </span>
                                    ) : (
                                        <span style={{ textTransform: 'uppercase' }} className="badge bg-success">
                                            {data.status}
                                        </span>
                                    )}
                                </p>
                            </Col>
                            <Col xs={12} className="mb-3">
                                <label className="form-label">Service Required</label>
                                <ul className="list-unstyled">
                                    {data?.service_required ? (
                                        data.service_required.split(',').map((service, index) => (
                                            <li key={index} className="mb-1">
                                                • {service.trim()}
                                            </li>
                                        ))
                                    ) : (
                                        <li>N/A</li>
                                    )}
                                </ul>
                            </Col>
                        </Row>
                    </div>

                    {/* Assignment Information */}
                    <div className="section-header">Assignment Information</div>
                    <div className="section-body">
                        <Row>
                            <Col xs={12} md={6} className="mb-3">
                                <label className="form-label">Assigned By</label>
                                <p>{data?.assignedBy?.name || 'N/A'}</p>
                            </Col>
                            <Col xs={12} md={6} className="mb-3">
                                <label className="form-label">Accepted By</label>
                                <p>{data?.assignedTo?.name || 'N/A'}</p>
                            </Col>
                            <Col xs={12} md={6} className="mb-3">
                                <label className="form-label">Job Posted To</label>
                                <ul className="list-unstyled">
                                    {data?.job_sended_to?.map((e) => (
                                        <li key={e.id}>#{e.id} {e.name}</li>
                                    )) || <li>N/A</li>}
                                </ul>
                            </Col>
                            {data?.workforce.length > 0 && (
                                <Col xs={12} md={6} className="mb-3">
                                    <label className="form-label">Workforce Team</label>
                                    <ul className="list-unstyled">
                                        {data?.workforce?.map((e) => (
                                            <li key={e.id}>#{e.id} {e.fullName}</li>
                                        )) || <li>N/A</li>}
                                    </ul>
                                </Col>
                            )}
                        </Row>
                    </div>

                    {/* Additional Information */}
                    <div className="section-header">Additional Information</div>
                    <div className="section-body">
                        <Row>
                            <Col xs={12} className="mb-3">
                                <label className="form-label">Created At</label>
                                <p>{data?.createdAt ? formatDate(data.createdAt) : 'N/A'}</p>
                            </Col>
                            <Col xs={12} className="mb-3">
                                <label className="form-label">Message</label>
                                <div className="description" dangerouslySetInnerHTML={{ __html: data?.message }} />
                            </Col>
                        </Row>
                    </div>
                    <div className="section-header">Status Roadmap</div>
                    <StatusRoadmap statusData={data?.job_status}/>

                    {/* Attachments */}
                    {data?.attachments != "[]" && (
                        <div className="section-header">Attachments</div>
                    )}
                    
                    
                    <div className='row'>
                        {data?.attachments ?
                            JSON.parse(data?.attachments).map((e) => (
                                <div
                                    className='col-md-2'
                                    onClick={() => openAttachmentSingle(API_URL + e)}
                                    style={{ cursor: 'pointer' }}
                                    key={e}
                                >
                                    <img
                                        src={API_URL + e}
                                        style={{ width: 200, height: 200, aspectRatio: 3 / 3, objectFit: 'cover' }}
                                    />
                                </div>
                            )) : (
                                <div>Nothing found</div>
                            )
                        }
                    </div>

                    {/* Remarks */}
                    <div className="section-header">Remarks</div>
                    <div className="section-body">
                        <Row>
                            <Col>
                                <RemarksRoadmap remarks={jobRemarks} />
                            </Col>
                            {
                                jobRemarks?.length === 0 ? <span>No remarks posted yet.....</span> : null
                            }
                        </Row>
                    </div>

                    {/* Photos */}
                    <div className="section-header">Photos</div>
                    <div className="section-body">
                        <Row className="mt-3">
                            {data?.images.map((e) => (
                                <Col md="3" key={e.id} className="image-container" onClick={() => openAttachment(e)}>
                                    <p>{formatDate(e.createdAt)}</p>
                                    <img src={API_URL + e.image_url} alt="Job Image" />
                                    <p className="image-status">{e.status}</p>
                                </Col>
                            )) }
                            {
                                data.images?.length === 0 ? <span>No images uploaded yet.....</span> : null
                            }
                        </Row>
                    </div>
                    <div className="section-header">Job Checklist</div>
                    <div className="section-body">
                        <Row>
                            <Col md="6" style={{display:'flex',justifyContent:'space-between'}}>
                                <p style={{fontWeight:'bold'}}>Functional Testing </p>
                                <span style={{ marginTop: -4 }}>
                                    {
                                        data?.functionalTesting === true ? 
                                        <Icon
                                            icon="fa-solid:check"
                                            width="14"
                                            height="14"
                                            style={{ borderWidth: 1 }}
                                        />:
                                        <span style={{borderWidth:1,padding:6,marginTop:4}}></span>
                                        }

                                    </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" style={{display:'flex',justifyContent:'space-between'}}>
                                <p style={{fontWeight:'bold'}}>Electricial Certificate Issue</p>
                                <span style={{ marginTop: -4 }}>
                                    {
                                        data?.certificateIssue === true ? 
                                        <Icon
                                            icon="fa-solid:check"
                                            width="14"
                                            height="14"
                                            style={{ borderWidth: 1 }}
                                        />:
                                        <span style={{borderWidth:1,padding:6,marginTop:4}}></span>
                                        }

                                    </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" style={{display:'flex',justifyContent:'space-between'}}>
                                <p style={{fontWeight:'bold'}}>Further Information</p>
                               
                            </Col>
                            <Col md="12" style={{display:'flex',justifyContent:'space-between'}}>
                                <div dangerouslySetInnerHTML={{__html: data?.futherDescription}}/>
                               
                            </Col>
                        </Row>
                    </div>

                </Card.Body>
            </Card>

            {/* Offcanvas for Chat History */}
            <Offcanvas show={showChat} onHide={handleCloseChat} placement="end">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Chat History (Job #{data?.id || 'N/A'})</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {data?.id && (
                        <ChatHistory jobId={data.id.toString()} senderId={senderId} />
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </Container>
    );
}
